import AsyncStorage from "@react-native-async-storage/async-storage";
import { TransactionItemTypeLetterEnum } from "@repo/core/constants/transactions";
import { InterestTypeEnum } from "@repo/core/enums/installments";
import { AuthorizerTermType } from "@repo/core/services/entities/Authorizer";
import { CardConsultDataResponseDTO } from "@repo/core/services/entities/Card";
import {
  NewTransactionState,
  NewTransactionStateValues,
  QRCodeData
} from "@repo/core/stores/newTransaction/types";
import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";
import { TransactionFlowType } from "@repo/core/screens/NewTransaction/types";
import { ROUTES } from "@repo/core/routes";
import { TransactionOperationEnum } from "@repo/core/enums/receipts";

const initialValues: NewTransactionStateValues = {
  // Flow Management
  flowType: TransactionFlowType.PURCHASE,
  currentRoute: ROUTES.newTransactionCaptureOptions,
  previousRoute: undefined,
  nextRoute: undefined,
  transactionOperation: TransactionOperationEnum.PURCHASE,
  // Form Values
  qrCodeInfo: undefined,
  bonusValue: 0,
  selectedInstallment: undefined,
  interestType: InterestTypeEnum.WITH_INTEREST,
  transactionValue: 0,
  isInstallmentsPayment: false,
  transactionType: TransactionItemTypeLetterEnum.COMPRA,
  selectedProduct: undefined,
  availableBonus: 0,
  discountedTransactionValue: 0
};

export const useNewTransactionStore = create<NewTransactionState>()(
  persist(
    (set) => ({
      ...initialValues,

      // Flow Management Actions
      setFlowType: (type: TransactionFlowType) => {
        set({ flowType: type });
      },
      setCurrentRoute: (route: string) => {
        set({ currentRoute: route });
      },
      setPreviousRoute: (route?: string) => {
        set({ previousRoute: route });
      },
      setNextRoute: (route?: string) => {
        set({ nextRoute: route });
      },
      setTransactionType: (type: TransactionItemTypeLetterEnum) => {
        set({ transactionType: type });
      },
      setTransactionOperation: (operation: TransactionOperationEnum) => {
        set({ transactionOperation: operation });
      },
      setQRCodeInfo: (info: QRCodeData) => {
        set({ qrCodeInfo: info });
      },
      setBonusValue: (value: number) => {
        set({ bonusValue: value });
      },
      setIsInstallmentsPayment: (value: boolean) => {
        set({ isInstallmentsPayment: value });
      },
      setSelectedInstallment: (value?: AuthorizerTermType) => {
        set({ selectedInstallment: value });
      },
      setInterestType: (type: InterestTypeEnum) => {
        set({ interestType: type });
      },
      setTransactionValue: (value: number) => {
        set({ transactionValue: value });
      },
      setSelectedProduct: (product: CardConsultDataResponseDTO) => {
        set({ selectedProduct: product });
      },
      setAvailableBonus: (value: number) => {
        set({ availableBonus: value });
      },
      setDiscountedTransactionValue: (value: number) => {
        set({ discountedTransactionValue: value });
      },
      resetNewTransaction: () => {
        set(initialValues as NewTransactionState);
      }
    }),
    {
      name: "NewTransactionStore",
      storage: createJSONStorage(() => AsyncStorage)
    }
  )
);
